// dom元素offsetParent属性表示距离该元素最近的一个position不为static的父级元素
// offsetTop表示该元素到 ”距离该元素最近的一个position不为static的父级元素的距离
//递归获取元素到窗口高度
function getElementTop(el, targetEl) {
  const parent = el.offsetParent;
  const top = el.offsetTop;
  return parent && parent !== targetEl
    ? getElementTop(parent, targetEl) + top
    : top;
}
//递归获取元素到窗口左边长度
function getElementLeft(el, targetEl) {
  const parent = el.offsetParent;
  const left = el.offsetLeft;
  return parent && parent !== targetEl
    ? getElementLeft(parent, targetEl) + left
    : left;
}
/**
 *  v-dialogDragOnly: 仅弹窗拖拽
 *  用法：在elementUi组件dialog上，添加v-dialogDragOnly
 */
Vue.directive("dialogDragOnly", {
  bind(el) {
    // el, binding, vnode, oldVnode
    const dialogHeaderEl = el.querySelector(".el-dialog__header");
    const dragDom = el.querySelector(".el-dialog");
    const headerDomHeight = document.querySelector(".el-header")?.clientHeight;
    dialogHeaderEl.style.cursor = "move";

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

    dialogHeaderEl.onselectstart = () => { return false }
    dialogHeaderEl.onmousedown = e => {
      const clientWidth = document.documentElement.clientWidth; // 浏览器可视工作区宽度
      const clientHeight = document.documentElement.clientHeight; // 浏览器可视工作区高度

      //获取当前的left/top值
      const styLeft = parseInt(sty.left)
      const styTop = parseInt(sty.top)
      //x1 x2 y1 y2 分别是xy轴上下能够移动的距离
      const y1 = getElementTop(dialogHeaderEl)- parseInt(sty.height)*0.5
      const y2 = clientHeight - parseInt(sty.height) - y1
      const x1 = getElementLeft(dialogHeaderEl) - parseInt(sty.width)*0.5
      const x2 = clientWidth - parseInt(sty.width) - x1

      const beginX = e.clientX
      const beginY = e.clientY

      let clientX, clientY, moveX, moveY

      document.onmousemove = function (e) {
        clientX = e.clientX
        clientY = e.clientY
        moveX = clientX - beginX
        moveY = clientY - beginY


        //边界值处理
        const m = 5 //四边留一定的空间
        if (moveX <= -x1) {
          moveX = -x1 + m
        }
        if (moveX >= x2) {
          moveX = x2 - m
        }
        if (moveY<0&&moveY <= -y1) {
          moveY = -y1 + m
        }
        // 往下移动，y2必须大于0，表示可以往下移动
        if (moveY >= y2&&moveY>0) {
          y2 >= 0?moveY = y2 - m:moveY=0;
        }
        const finalX = styLeft + moveX
        const finalY = styTop + moveY
        dragDom.style.left = `${finalX}px`;
        dragDom.style.top = `${finalY}px`;
      };

      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});
Vue.directive("elementDrag", {
  inserted(el,binding) {
    // el, binding, vnode, oldVnode
    const {value:className} = binding
    const dialogHeaderEl = el.querySelector(`.${className}`);
    if(!dialogHeaderEl) return
    const dragDom = el
    // const headerDomHeight = document.querySelector(`.${className}`)?.clientHeight;
    dialogHeaderEl.style.cursor = "move";

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

    dialogHeaderEl.onselectstart = () => { return false }
    dialogHeaderEl.onmousedown = e => {
      const clientWidth = document.documentElement.clientWidth; // 浏览器可视工作区宽度
      const clientHeight = document.documentElement.clientHeight; // 浏览器可视工作区高度

      //获取当前的left/top值
      const styLeft = parseInt(sty.left)
      const styTop = parseInt(sty.top)
      //x1 x2 y1 y2 分别是xy轴上下能够移动的距离
      const y1 = getElementTop(dialogHeaderEl)- parseInt(sty.height)*0.5
      const y2 = clientHeight - parseInt(sty.height) - y1
      const x1 = getElementLeft(dialogHeaderEl) - parseInt(sty.width)*0.5
      const x2 = clientWidth - parseInt(sty.width) - x1

      const beginX = e.clientX
      const beginY = e.clientY

      let clientX, clientY, moveX, moveY

      document.onmousemove = function (e) {
        clientX = e.clientX
        clientY = e.clientY
        moveX = clientX - beginX
        moveY = clientY - beginY


        //边界值处理
        const m = 5 //四边留一定的空间
        if (moveX <= -x1) {
          moveX = -x1 + m
        }
        if (moveX >= x2) {
          moveX = x2 - m
        }
        if (moveY<0&&moveY <= -y1) {
          moveY = -y1 + m
        }
        // 往下移动，y2必须大于0，表示可以往下移动
        if (moveY >= y2&&moveY>0) {
          y2 >= 0?moveY = y2 - m:moveY=0;
        }
        const finalX = styLeft + moveX
        const finalY = styTop + moveY
        dragDom.style.left = `${finalX}px`;
        dragDom.style.top = `${finalY}px`;
      };

      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});